import styles from "./headerTitle.module.css";

const HeaderTitle = ({ title, children, icon }) => {
  return (
    <div className={styles.titleContainer}>
      <div className={styles.titleBlock}>
        {icon && <img src={icon} alt="Ícone" className={styles.icon} />}
        <h1>{title}</h1>
      </div>

      {children && <div className={styles.actions}>{children}</div>}
    </div>
  );
};

export default HeaderTitle;
